import { useCallback } from 'react';

import { useLinkCashbackAccountMutation } from '@ocx/graphql';

import { AllureCashbackSetupFormValues, mapSetupFormValuesToLinkCashbackAccountInput } from './allure-cashback.utils';

export type UseLinkAllureCashbackAccountProps = {
  onCompleted?: () => void;
  onError?: (error: unknown) => void;
};

export const useLinkAllureCashbackAccount = ({ onCompleted, onError }: UseLinkAllureCashbackAccountProps = {}) => {
  const [link, { loading }] = useLinkCashbackAccountMutation({
    onCompleted,
    onError,
  });

  const linkCashbackAccount = useCallback(
    async (values: AllureCashbackSetupFormValues) => {
      const result = await link({
        variables: {
          input: mapSetupFormValuesToLinkCashbackAccountInput(values),
        },
      });

      return result.data?.linkCashbackAccount;
    },
    [link],
  );

  return { linkCashbackAccount, loading };
};
